import React, { Component } from 'react'
import Fade from 'react-reveal/Fade'

import Map from './map' 

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

class Form extends Component {

  state = {
    name: '',
    email: '',
    phone_number: '',
    message: '',
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleSubmit = e => {
    e.preventDefault()

    if ( this.state.type === '' ) {
      this.setState({ type_valid: false })
      return false
    }

    if (!this.refs.form.checkValidity()) return false

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": this.refs.form.getAttribute("name"),
        ...this.state
      })
    })
      .then(() => this.setState({result: 'success'}))
      .catch(error => this.setState({result: 'fail', msg: error}))
  }

  render() {
    let { form_title, confirmation_message } = this.props
    let props = {
      ref: 'form',
      name: 'contact',
      className: 'form',
      onSubmit: this.handleSubmit,
      'data-netlify': 'true',
      'data-netlify-honeypot': 'bot-field',
    }

    if (this.state.result === 'success')
      return (<p className='form__success' dangerouslySetInnerHTML={{ __html: confirmation_message }} />)

    return (
      <form {...props}>
        <div className='form__row'>
          <h2>{form_title}</h2>
        </div>
        <div className='form__row'>
          <input type='text' name='name' placeholder='Name' onChange={this.handleChange} required />
        </div>
        <div className='form__row'>
          <input type='email' name='email' placeholder='Email' onChange={this.handleChange} required  />
        </div>
        <div className='form__row'>
          <input type='text' name='phone_number' placeholder='Phone Number' onChange={this.handleChange} required  />
        </div>
        <div className='form__row'>
          <textarea name='enquiry' placeholder='Message' onChange={this.handleChange} />
        </div>
        <div className='form__row form__row--submit'>
          <button class='btn' type='submit'>Submit</button>
        </div>
      </form>
    )
  }
}

class Contact extends Component {

  render() {
  	const { office, form_title, confirmation_message } = this.props
    return (
      <section className='contact-block'>
        <div className='contact-block__inner'>
          <Fade bottom distance={'40px'} delay={300}>
            <h1>{office.title}</h1>
            <div className='contact-block__office'>
              <div className='contact-block__address' dangerouslySetInnerHTML={{ __html: office.address }} />
              <div className='contact-block__btn-wrap phone'>
                <a className='btn' href={`tel:${office.phone}`}>{office.phone}</a>
              </div>
              <div className='contact-block__btn-wrap'>
                <a className='btn' href={`mailto:${office.email}`}>{office.email}</a>
              </div>
              <div className='contact-block__btn-wrap linkedin'>
                <a className='btn' href={office.linkedin} target='_blank' rel='noopener noreferrer'>LinkedIn</a>
              </div>
            </div>
          </Fade>
          <Fade bottom distance={'40px'} delay={300}>
            <Map lat={office.map.lat} lng={office.map.lng} />
            <Form form_title={form_title} confirmation_message={confirmation_message} />
          </Fade>
        </div>
      </section>
    )
  }
}

export default Contact
